// extracted by mini-css-extract-plugin
module.exports = {"ldsSpinner":"VideoSpinner_ldsSpinner__2Gh5f","lds-spinner":"VideoSpinner_lds-spinner__2xjja"};